<template>
    <div class="d-flex align-items-center data">
        <tool-icon v-if="icon != undefined" :name="icon" :style="icon_style" class="ma-1" />
        <div v-if="linethrough" class="linethrough">
            <slot>{{ content }}</slot>
        </div>
        <template v-else>
            <slot>{{ content }}</slot>
        </template>
        <v-spacer></v-spacer>
        <tool-button v-if="action != undefined" :context="action" :icon="action.icon" :onclick="action.onclick"
            :title="action.title" />
        <tool-button-context v-if="actions != undefined" :actions="actions" />
    </div>
</template>

<script>
import ToolButton from './ToolButton.vue';
import ToolButtonContext from './ToolButtonContext.vue';
import ToolIcon from './ToolIcon.vue';

export default {
    name: 'TableSimpleValue',
    components: {
        ToolButtonContext,
        ToolButton,
        ToolIcon,
    },
    props: ['value'],
    computed: {
        content() {
            const value = this.value;
            if (value == null) {
                return '';
            } if (value.value != null) {
                return value.value;
            }
            return value;
        },
        actions() {
            return this.value?.actions;
        },
        action() {
            return this.value?.action;
        },
        icon() {
            return this.value?.icon;
        },
        icon_style() {
            if (this.value.color != null) {
                return `color:${this.value.color};`;
            }
            return '';
        },
        linethrough() {
            return this.value?.linethrough;
        },
    },
};
</script>

<style scoped>
.data {
    text-overflow: ellipsis;
    overflow: hidden;
}

.linethrough {
    text-decoration: line-through;
}
</style>
